export interface TenantWebRuntimeConfig {
  moduleVersionsUrl?: string;
  tenantID?: string;
  realm?: string;
  appId?: string;
  apiBaseURL?: string;
  remoteI18n?: boolean;
  showLanguageSwitcher?: boolean;
  mode?: string;
  miniBaseURL?: string;
  workspaceNotice?: {
    externalOrigins?: string[];
  };
  deviceControl?: {
    baseUrl?: string;
    regionUrls?: Record<string, string>;
  };
}

type ReactRuntime = typeof import('react');
type AntdRuntime = typeof import('@yimoka/antd');

const configWindowKey = '__TENANT_WEB_CONFIG__';
const qiyunConfigWindowKey = '_qiyun_config';
const reactWindowKey = '__TENANT_WEB_REACT__';
const antdWindowKey = '__TENANT_WEB_ANTD__';

type TenantWebWindow = Window & {
  [configWindowKey]?: TenantWebRuntimeConfig;
  [qiyunConfigWindowKey]?: TenantWebRuntimeConfig;
  [reactWindowKey]?: ReactRuntime;
  [antdWindowKey]?: AntdRuntime;
};

function getRuntimeWindow(): TenantWebWindow {
  return window as TenantWebWindow;
}

export function getRuntimeConfig(): TenantWebRuntimeConfig | undefined {
  const runtimeWindow = getRuntimeWindow();
  return runtimeWindow[configWindowKey] ?? runtimeWindow[qiyunConfigWindowKey];
}

export function setRuntimeConfig(config: TenantWebRuntimeConfig | undefined): void {
  getRuntimeWindow()[configWindowKey] = config;
}

export function getRuntimeReact(): ReactRuntime | undefined {
  return getRuntimeWindow()[reactWindowKey];
}

export function setRuntimeReact(react: ReactRuntime | undefined): void {
  getRuntimeWindow()[reactWindowKey] = react;
}

export function getRuntimeAntd(): AntdRuntime | undefined {
  return getRuntimeWindow()[antdWindowKey];
}

export function setRuntimeAntd(antd: AntdRuntime | undefined): void {
  getRuntimeWindow()[antdWindowKey] = antd;
}
